<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="wo_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.wo_type || "申请类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.wo_type"
              @change="onWotypeChange"
              placeholder="请选择"
            >
              <option>个人</option>
              <option>组织</option>
            </select>
          </div>
        </div>
        <department-field
          slot="wo_department"
          v-if="form.main.wo_type == '组织'"
          v-model="form.main.wo_department"
          @select="onSelectDepartment"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="wo_accountway"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.wo_accountway || "核算方式"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.wo_accountway"
              placeholder="请选择"
            >
              <option>申请调休</option>
              <option>申请加班费</option>
              <option>义务加班</option>
            </select>
          </div>
        </div>
        <datetime-field
          slot="wo_startime"
          :label="customLabel.wo_startime || '开始时间'"
          v-model="form.main.wo_startime"
        />
        <datetime-field
          slot="wo_endtime"
          :label="customLabel.wo_endtime || '结束时间'"
          v-model="form.main.wo_endtime"
        />
        <div class="weui-cell" slot="wo_count">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.wo_count || "加班时长"
            }}</label>
          </div>
          <div class="weui-cell__bd flex">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.wo_count"
              placeholder="请填写"
              minvalue="0"
            />
          </div>
        </div>
        <div class="weui-cell" slot="wo_remark">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.wo_remark || '加班目的'"
              rows="3"
              v-model="form.main.wo_remark"
              maxlength="100"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.wo_remark ? form.main.wo_remark.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>
        <file-field v-model="form.main.wo_attach" slot="wo_attach"/>
      </custom-layout>
      
      <div v-if="form.main.wo_type == '组织'">
        <div class="weui-cells__group" v-for="(item, xindex) in form.items" :key="xindex">
          <div class="weui-cells__title">
            <span>人员{{xindex+1}}</span>
            <a href="javascript:;" class="header-tool" @click="removeItem(xindex)">
              <span>删除</span>
            </a>
          </div>
          <div class="weui-cells">
            <employee-field
              ref="emf"
              label="姓名"
              v-model="item.wd_emname"
              @select="onSelectEmployee($event, item)"
            />
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">工号</label>
              </div>
              <div class="weui-cell__bd">{{item.wd_emcode}}</div>
            </div>
            <a
              href="javascript:"
              v-if="form.items && xindex==form.items.length-1"
              class="weui-cell weui-cell_link"
              @click="addItem"
            >
              <div class="weui-cell__bd">添加更多</div>
            </a>
          </div>
        </div>
      </div>

    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import FileField from "@/components/field/FileField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DepartmentField,
    DatetimeField,
    FileField,
    EmployeeField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/workovertime",
      codeField: "wo_code",
      statusField: "wo_statuscode",
      caller: "WorkOverTime",
      xtype: 'oa-workovertime-formpanel',
      form: {
        main: {
          wo_type: "个人",
          wo_department: '',
          wo_departmentid: null,
          wo_depcode: null,
          wo_accountway: "申请调休",
          wo_startime: null,
          wo_endtime: null,
          wo_remark: null,
          wo_count: 0
        },
        items: [

        ]
      }
    };
  },
  computed: {
    wo_startime() {
      return this.form.main.wo_startime;
    },
    wo_endtime() {
      return this.form.main.wo_endtime;
    }
  },
  watch: {
    wo_startime: function () {
      this.countHourDiff()
    },
    wo_endtime: function () {
      this.countHourDiff()
    }
  },
  methods: {
    onWotypeChange(e) {
      this.form.main.wo_department = ''
      this.form.main.wo_departmentid = null
      this.form.main.wo_depcode = ''

      if(e.target.value == '个人') {
        this.form.items = []
      } else {
        this.form.items = [
        {
            wd_detno: 1,
            wd_emcode: "",
            wd_emid: null,
            wd_emname: "",
            id: 0
          }
        ]
      }
    },
    onSelectDepartment(selection) {
      var me = this,
        main = me.form.main;
      main.wo_departmentid = selection.id;
      main.wo_depcode = selection.dp_code

      me.$refs.emf.forEach((item) => {
        item.defaultCondition.push({
          field: "em_dpid",
          operation: "=",
          value: selection.id
        })
      })
      me.initEm(selection.id)
    },
    onSelectEmployee(selection, item) {
      item.wd_emcode = selection.em_code,
      item.wd_emid = selection.id,
      item.wd_emname = selection.em_name
    },
    initEm(id) {
      let me = this
      me.$loading({
        url: '/api/document/employee/list',
        params: {
          condition: JSON.stringify([
            {
              type: "condition",
              value: `em_dpid=${id} and em_class='正式'`
            }
          ])
        }
      }).then(function (res) {
        if(!res.success) {
          me.$weui.topTips(res.message || '获取部门人员错误', 2000);
        } else if (res.data.list.length == 0) {
          me.$weui.topTips("该部门无人员，请重新选择", 2000);

          me.form.main.wo_department = ''
          me.form.main.wo_departmentid = null
          me.form.main.wo_depcode = ''

          me.form.items = [
            {
              wd_detno: 1,
              wd_emcode: "",
              wd_emid: null,
              wd_emname: "",
              id: 0
            }
          ]
        } else {
          let result = res.data.list.map((item, index) => {
            return {
              id: 0,
              wd_detno: index + 1,
              wd_emcode: item.em_code,
              wd_emid: item.id,
              wd_emname: item.em_name
            }
          })
          
          me.form.items = result
        }
      });
    },
    /**
     * 日期选择最小单位是一刻钟，计算出的0.25 0.75需要变为0.5 1
     */
    countHourDiff() {
      var {wo_startime, wo_endtime} = this.form.main;

      if (!wo_startime || !wo_endtime) return

      wo_startime = wo_startime.replace(' ', 'T')
      wo_endtime = wo_endtime.replace(' ', 'T')

      var s_time = new Date(wo_startime).getTime(),
        e_time = new Date(wo_endtime).getTime(),
        wo_count = e_time - s_time;

      if(wo_count < 0) {
        this.$weui.topTips("结束时间需要大于开始时间", 2000);
        return
      }

      wo_count = wo_count/1000/60/60
      // let temp_wo_count = wo_count * 100 + ''
      // let a = temp_wo_count.at(-2)
      // if(a == 7 || a == 2) wo_count -= 0.25

      this.form.main.wo_count = wo_count
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.wo_startime) {
        me.$weui.topTips("请选择开始时间", 2000);
      } else if (!main.wo_endtime) {
        me.$weui.topTips("请选择结束时间", 2000);
      } else if (main.wo_type == '组织' && !main.wo_depcode) {
        me.$weui.topTips("请选择部门", 2000);
      } else if (!main.wo_remark) {
        me.$weui.topTips("请填写加班目的", 2000);
      } else if (Number(main.wo_count) < 0 || isNaN(Number(main.wo_count))) {
        me.$weui.topTips("请正确填写加班时长", 2000);
      } else {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      index == 0 ? me.$weui.topTips("请至少保留一行", 2000) : items.splice(index, 1)
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        wd_detno: items.length,
        wd_emcode: "",
        wd_emid: null,
        wd_emname: "",
        id: 0
      });
    },
  }
};
</script>